<div class="container-fluid mt-2">
  <div class="row">
    <div class="col-md-6">
      <p-tabView (onChange)="onTabChange($event)">
        <!-- 1️⃣ Medical/Health Certificates -->
        <p-tabPanel header="Medical/Health Certificates">
          <form [formGroup]="medicalForm" class="certificate-form p-fluid">
            <div class="row g-2">
              <div class="col-md-6">
                <label>Patient Name</label>
                <p-autoComplete
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  [ngModelOptions]="{ standalone: true }"
                  (onSelect)="onPatientSelect($event)"
                  field="full_name"
                  placeholder="Search by name, number, or contact"
                  [forceSelection]="true"
                  emptyMessage="No patients found"
                  class="w-100"
                >
                </p-autoComplete>
              </div>

              <div class="col-md-6">
                <label>Select Certificate Type</label>
                <p-dropdown
                  [options]="medicalTypes"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="certificateType"
                  placeholder="Select Certificate"
                  (onChange)="onTypeChange('medical')"
                >
                </p-dropdown>
              </div>

              <div class="col-md-6">
                <label>Remarks</label>
                <textarea
                  rows="3"
                  pInputTextarea
                  formControlName="remarks"
                ></textarea>
              </div>
              <div class="col-md-2">
                <label>Date</label>
                <p-calendar
                  formControlName="date"
                  dateFormat="dd-mm-yy"
                ></p-calendar>
              </div>
              <div class="col-md-4">
                <label class="d-block">Paper Size</label>
                <div class="d-flex gap-3 mt-2">
                  <div class="flex align-items-center">
                    <p-radioButton
                      name="paperSize"
                      value="a5"
                      label="A5 (Half)"
                      formControlName="paperSize"
                    ></p-radioButton>
                  </div>
                  <div class="flex align-items-center">
                    <p-radioButton
                      name="paperSize"
                      value="a4"
                      label="A4 (Full)"
                      formControlName="paperSize"
                    ></p-radioButton>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <label>Certificate Body</label>
              <p-editor
                formControlName="certificateBody"
                (onTextChange)="onEditorTextChange($event, 'medical')"
                [style]="{ height: '220px' }"
              ></p-editor>
            </div>

            <div class="col-md-3 mt-2">
              <button
                pButton
                type="button"
                label="Generate PDF"
                class="view-button-success"
                (click)="generatePDFlocally('medical')"
              ></button>
              <!-- <button pButton type="button" label="Generate PDF" (click)="generatePDF('medical')"></button> -->
            </div>
          </form>
        </p-tabPanel>

        <!-- 2️⃣ Travel/Activity Certificates -->
        <p-tabPanel header="Travel/Activity Certificates">
          <form [formGroup]="travelForm" class="certificate-form p-fluid">
            <div class="row g-2">
              <div class="col-md-6">
                <label>Patient Name</label>
                <p-autoComplete
                  [(ngModel)]="selectedPatient"
                  [suggestions]="patientsList"
                  (completeMethod)="searchPatients($event)"
                  [ngModelOptions]="{ standalone: true }"
                  (onSelect)="onPatientSelect($event)"
                  field="full_name"
                  placeholder="Search by name, number, or contact"
                  [forceSelection]="true"
                  emptyMessage="No patients found"
                  class="w-100"
                >
                </p-autoComplete>
              </div>
              <!-- <div class="col-md-2">
                <label>Age</label>
                <input type="number" pInputText formControlName="age" />
              </div>
              <div class="col-md-2">
                <label>Gender</label>
                <input type="text" pInputText formControlName="gender" />
              </div> -->
              <div class="col-md-6">
                <label>Select Certificate Type</label>
                <p-dropdown
                  [options]="travelTypes"
                  optionLabel="label"
                  optionValue="value"
                  formControlName="certificateType"
                  placeholder="Select Certificate"
                  (onChange)="onTypeChange('travel')"
                >
                </p-dropdown>
              </div>

              <!-- <div class="col-md-4">
                <label>Doctor Name</label>
                <input type="text" pInputText formControlName="doctorName" />
              </div> -->
              <div class="col-md-6">
                <label>Remarks</label>
                <textarea
                  rows="3"
                  pInputTextarea
                  formControlName="remarks"
                ></textarea>
              </div>
              <div class="col-md-2">
                <label>Date</label>
                <p-calendar
                  formControlName="date"
                  dateFormat="dd-mm-yy"
                ></p-calendar>
              </div>
              <div class="col-md-4">
                <label class="d-block">Paper Size</label>
                <div class="d-flex gap-3 mt-2">
                  <div class="flex align-items-center">
                    <p-radioButton
                      name="paperSize"
                      value="a5"
                      label="A5 (Half)"
                      formControlName="paperSize"
                    ></p-radioButton>
                  </div>
                  <div class="flex align-items-center">
                    <p-radioButton
                      name="paperSize"
                      value="a4"
                      label="A4 (Full)"
                      formControlName="paperSize"
                    ></p-radioButton>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12">
              <label>Certificate Body</label>
              <p-editor
                formControlName="certificateBody"
                (onTextChange)="onEditorTextChange($event, 'travel')"
                [style]="{ height: '220px' }"
              ></p-editor>
            </div>

            <div class="col-md-3 mt-2">
              <button
                pButton
                type="button"
                label="Generate PDF"
                class="view-button-success"
                (click)="generatePDFlocally('travel')"
              ></button>
            </div>
          </form>
        </p-tabPanel>

        <!-- 3️⃣ Hospital/Discharge Certificates -->
        <!-- <p-tabPanel header="Hospital/Discharge Certificates">
      <form [formGroup]="hospitalForm" class="certificate-form p-fluid">
        <div class="row g-2">
          <div class="col-md-6">
            <label>Patient Name</label>
            <input type="text" pInputText formControlName="patientName" />
          </div>
          <div class="col-md-2">
            <label>Age</label>
            <input type="number" pInputText formControlName="age" />
          </div>
          <div class="col-md-2">
            <label>Gender</label>
            <input type="text" pInputText formControlName="gender" />
          </div>
          <div class="col-md-2">
            <label>Date</label>
            <p-calendar formControlName="date" dateFormat="dd-mm-yy"></p-calendar>
          </div>
          <div class="col-md-4">
            <label>Doctor Name</label>
            <input type="text" pInputText formControlName="doctorName" />
          </div>


          <div class="col-md-4">
            <label>Discharge Certificate </label>
            <p-dropdown [options]="hospitalTypes" optionLabel="label" optionValue="value"
              formControlName="certificateType" placeholder="Select Certificate" (onChange)="onTypeChange('hospital')">
            </p-dropdown>
          </div>
          <div class="col-md-4">
            <label>Remarks</label>
            <textarea rows="3" pInputTextarea formControlName="remarks"></textarea>
          </div>
        </div>

        <div class="col-md-12">
          <label>Certificate Body</label>
          <p-editor formControlName="certificateBody" [style]="{ height: '220px' }"></p-editor>
        </div>

        <div class="col-md-3">
          <button pButton type="button" label="Generate PDF" (click)="generatePDF('hospital')"></button>
        </div>
      </form>
    </p-tabPanel> -->
      </p-tabView>
    </div>
    <div class="col-md-6">
      <div class="preview" *ngIf="previewData">
        <div class="certificate">
          <!-- HEADER -->
          <div class="header">
            <img src="{{ logo }}" alt="logo" />
            <div class="clinic-info">
              <small
                >Sr. No. 2/14, Opp. Purandar (MHADA) Building, Near
                Paneerwala,</small
              >
              <small>Maharshi Nagar, Pune, Maharashtra – 411037</small>
              <small
                >Ph: 8070 7080 01/02/03 | Email:
                drshaileshsancheti&#64;gmail.com</small
              >
              <small></small>
            </div>
          </div>

          <div class="sub-header">
            <div class="specialization">
              SPECIALIZED IN THYROID, HAIR, SKIN & DIABETES
            </div>
            <div class="timing">
              Time: Morning - 11 am to 2 pm | Evening - 6 pm to 8 pm
            </div>
          </div>

          <!-- <hr /> -->

          <!-- PATIENT INFO -->
          <div class="info">
            <div><b>Patient Name:</b> {{ previewData.patientName }}</div>
            <div>
              <b>Age / Sex:</b> {{ previewData.age }} / {{ previewData.gender }}
            </div>
            <div>
              <b>Date of Examination:</b> {{ previewData.dateFormatted }}
            </div>
            <div><b>Doctor:</b> {{ previewData.doctorName }}</div>
          </div>

          <h3 class="type">
            {{ previewData.certificateType | uppercase }}
          </h3>

          <!-- BODY -->
          <div class="body" [innerHTML]="previewData.certificateBody"></div>

          <!-- REMARKS -->
          <div *ngIf="previewData.remarks" class="remarks">
            <b>Remarks:</b> {{ previewData.remarks }}
          </div>

          <!-- FOOTER -->
          <div class="footer-sign">
            <div class="sign">Doctor Signature & Stamp</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
